import React, { useState, useEffect } from "react";
import { Group, Arrow, Label, Text, Tag } from "react-konva";
import BrandColors from "../../../../../../styles/BrandColors";

const Connector = (props) => {
  const {
    connector = {},
    selectedRecordId,
    onLblDblClick,
  } = props;

  const { JLLBrandColors } = BrandColors;
  const { Red, Steel } = JLLBrandColors;

  const [labelPos, setLabelPos] = useState({});
  const [arrowPoints, setArrowPoints] = useState([]);
  const [color, setColor] = useState();

  useEffect(() => {
    const { sourceRec, targetRec, points } = connector;
    if (sourceRec && targetRec && points) {
      let cp = targetRec.connectorPoints[sourceRec.id];
      if (!cp) {
        cp = { x: targetRec.x + targetRec.width / 2, y: targetRec.y + targetRec.height };
      }
      const p = points.length > 2 ? points[points.length - 3] : cp.x;
      const x = cp.x - 10;
      const y = cp.y + 7;
      setLabelPos({
        x,
        y,
      });
      const arrowPoints = [];
      points.forEach(p => {
        arrowPoints.push(p.x, p.y);
      });
      setArrowPoints(arrowPoints);
    }
  }, [connector.sourceRec, connector.targetRec, connector.points]);

  useEffect(() => {
    setColor(
      connector.sourceRec.id === selectedRecordId ? Red.core :
        connector.targetRec.id === selectedRecordId ? Steel.core :
          Steel.tint25Percent
    );
  }, [connector.sourceRec, connector.targetRec, selectedRecordId]);

  const onDblClick = () => {
    onLblDblClick(connector);
  };

  return (
    <Group visible={!connector.hide} >
      <Arrow points={arrowPoints} fill={color} stroke={color} tension={0.0} strokeWidth={1}
        pointerLength={5}
        pointerWidth={5} />
      <Label x={labelPos.x} y={labelPos.y} opacity={1} onDblClick={onDblClick}>
        <Tag fill="white" />
        <Text text={connector.label} align="center" fill={color} fontSize={10} />
      </Label>
    </Group>
  );
};

export default Connector;
